module.exports = __webpack_public_path__ + "static/media/item_sli_recent_des.86e66427.png";